import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Container } from "reactstrap";
import { APP_CONST, getStoredItem, resetStorage } from "../../store/dataStore";
import {
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarNav,
} from "@coreui/react";

// sidebar nav config
import nav_manager from "../../navigations/_nav_manager";
import nav_authorizer from "../../navigations/_nav_authorizer";
import nav_admin from "../../navigations/_nav_admin";
import nav_auditor from "../../navigations/_nav_auditor";
import nav_re_installation from "../../navigations/_nav_keyholder_re_install";
import nav_registration from "../../navigations/_nav_keyholder_registration";
// routes config
import routes from "../../routes";
import DefaultHeader from "./DefaultHeader";
import DefaultFooter from "./DefaultFooter";
import IdleTimer from "react-idle-timer";
import swal from "sweetalert2";
import endpoints from "@/util/endpoints";

class DefaultLayout extends Component {
  state = {
    userInfo: {
      userAccountDTO: {
        firstName: "",
        lastName: "",
        authorities: [""],
      },
    },
    nav_: getStoredItem(APP_CONST.APP_NAV_MENU), // string only
    access_token: getStoredItem(APP_CONST.SEC_TOKEN),
    user_type: getStoredItem(APP_CONST.USER_TYPE),
    user_roles: JSON.parse(getStoredItem(APP_CONST.USER_ROLES)),
    user_authorities: JSON.parse(getStoredItem(APP_CONST.USER_AUTHORITIES)),
    user_action: getStoredItem(APP_CONST.CURRENT_ACTION),
    app_nav: "",
    timerInterval: 30000,
  };

  idleTimer = null;

  /**
   * Check if the user is authorized.
   */
  verifyUser = () => {
    // only allow if there is accessToken available or user is logged in.
    // only userType and Nav matching to allow user proceed
    if (
      getStoredItem(APP_CONST.CURRENT_ACTION) !== APP_CONST.ACTION_REINSTALL
    ) {
      if (this.state.access_token && this.state.user_type && this.state.nav_) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  getMenu = () => {
    const nav = { items: [] };

    let app_nav = null;
    if (this.state.user_action === APP_CONST.ACTION_REINSTALL) {
      if (this.state.nav_ === APP_CONST.NAV_RE_INSTALL) {
        app_nav = nav_re_installation;
      }
    } else if (
      this.state.access_token &&
      this.state.user_type &&
      this.state.nav_
    ) {
      switch (this.state.nav_) {
        case "nav_registration":
          app_nav = nav_registration;
          break;
      }

      if (app_nav) {
        return app_nav;
      }
    }

    for (let role of this.state.user_authorities) {
      let items;
      switch (role) {
        case "ROLE_ADMINISTRATOR":
          items = nav_admin.items;
          break;
        case "ROLE_MANAGER":
          items = nav_manager.items;
          break;
        case "ROLE_AUTHORIZER":
          items = nav_authorizer.items;
          break;
        case "ROLE_AUDITOR":
          items = nav_auditor.items;
          break;
      }

      for (let item of items) {
        const index = nav.items.findIndex(i => i.url === item.url);

        if (index !== -1) {
          item.children = item.children || [];
          nav.items[index].children = nav.items[index].children || [];

          for (let childItem of item.children) {
            const childIndex = nav.items[index].children.findIndex(
              i => i.url === childItem.url,
            );
            if (childIndex === -1) {
              nav.items[index].children.push(childItem);
            }
          }
        } else {
          nav.items.push(item);
        }
      }
    }

    const permissions = [
      ...new Set(
        this.state.user_roles.reduce(
          (result, role) => result.concat(role.permissions),
          [],
        ),
      ),
    ];
    const pages = endpoints;

    for (let page of pages) {
      if (page.children) {
        for (let childPage of page.children) {
          const shouldBeAdded =
            childPage.permissions &&
            childPage.permissions.length &&
            childPage.permissions.filter(p => !permissions.includes(p))
              .length === 0;
          let alreadyExists = false;

          for (let item of nav.items) {
            if (alreadyExists) {
              break;
            }
            if (item.url === childPage.url) {
              alreadyExists = true;
              break;
            }

            if (item.children) {
              for (let childItem of item.children) {
                if (childItem.url === childPage.url) {
                  alreadyExists = true;
                  break;
                }
              }
            }
          }

          if (shouldBeAdded && !alreadyExists) {
            let parent = nav.items.find(i => i.url === page.url);
            if (parent) {
              parent.children.push(childPage);
            } else {
              nav.items.push({ ...page, children: [childPage] });
            }
          }
        }
      } else {
        const shouldBeAdded =
          page.permissions &&
          page.permissions.length &&
          page.permissions.filter(p => !permissions.includes(p)).length === 0;
        let alreadyExists = false;

        for (let item of nav.items) {
          if (alreadyExists) {
            break;
          }
          if (item.url === page.url) {
            alreadyExists = true;
            break;
          }

          if (item && item.children) {
            for (let childItem of item.children) {
              if (childItem.url === page.url) {
                alreadyExists = true;
                break;
              }
            }
          }
        }

        if (shouldBeAdded && !alreadyExists) {
          nav.items.push(page);
        }
      }
    }

    return nav;
  };

  /**
   * Render a sidebar's header
   */
  shouldRenderSideBarHeader = () => {
    if (
      this.state.user_action === APP_CONST.ACTION_REGISTRATION ||
      this.state.user_action === APP_CONST.ACTION_RE_INSTALLATION
    ) {
      return (
        <div className="text-left">
          <p>
            <strong>
              {this.state.userInfo.userAccountDTO.lastName +
                " " +
                this.state.userInfo.userAccountDTO.firstName}
            </strong>
          </p>
          <p>Username: {this.state.userInfo.userAccountDTO.login}</p>
          <p>Role: {this.state.userInfo.userAccountDTO.authorities[0]}</p>
        </div>
      );
    } else {
      return <></>;
    }
  };

  /**
   * Populate the state "userInfo" with stored data.
   */
  settingData = () => {
    this.setState({
      userInfo: JSON.parse(getStoredItem(APP_CONST.USER_INFO)),
    });
  };

  // idle detection
  onAction = e => {
    // refreshing token
    // alert user if session almost expired
  };

  onActive = e => {
    // refreshing token/session
  };

  onIdle = e => {
    swal({
      title: "You have been idled for too long",
      html: "I will close in <strong></strong> seconds.",
      timer: this.state.timerInterval,
      confirmButtonText: "Continue my session",
      cancelButtonText: "Logout now",
      showCancelButton: true,
      onBeforeOpen: () => {
        this.setState({
          timerInterval: setInterval(() => {
            swal.getContent().querySelector("strong").textContent = (
              swal.getTimerLeft() / 1000
            ).toFixed(0);
          }, 100),
        });
      },
      onClose: () => {
        clearInterval(this.state.timerInterval);
        this.setState({ timerInterval: 30000 });
      },
    }).then(result => {
      // only this reason will logout other else just ignore.
      if (result.dismiss === "cancel" || result.dismiss === "timer") {
        // logout
        this.logout();
      }

      //else if (result.dismiss === 'overlay' || result == true) {
      // continue
      //}
    });
  };

  // actions when idleTimer
  logout = () => {
    resetStorage();
    this.props.history.push({ pathname: "/", state: {} });
  };
  // end idle detection

  render() {
    // TODO: shouldn't it be called in some lifecycle hook?
    if (this.verifyUser()) {
      if (!this.state.user_action === APP_CONST.ACTION_RE_INSTALLATION) {
        this.settingData();
      }
      return (
        <div className="app">
          <AppHeader className="navbar navbar-dark bg-dark" fixed>
            <DefaultHeader history={this.props.history} />
          </AppHeader>
          <IdleTimer
            ref={ref => {
              this.idleTimer = ref;
            }}
            element={document}
            onActive={this.onActive}
            onIdle={this.onIdle}
            onAction={this.onAction}
            debounce={250}
            timeout={1000 * 60 * 15}
          />
          <div className="app-body">
            <AppSidebar fixed display="lg">
              <AppSidebarHeader>
                {this.shouldRenderSideBarHeader()}
              </AppSidebarHeader>
              <AppSidebarForm />
              <AppSidebarNav navConfig={this.getMenu()} {...this.props} />
              <AppSidebarFooter />
            </AppSidebar>
            <main className="main">
              <AppBreadcrumb appRoutes={routes} />
              <Container fluid>
                <Switch>
                  {routes.map((route, idx) => {
                    return route.component ? (
                      <Route
                        key={idx}
                        path={route.path}
                        exact={route.exact}
                        name={route.name}
                        render={props => <route.component {...props} />}
                      />
                    ) : null;
                  })}
                  {/* TODO redirect user when login or not */}
                  <Redirect from="/" to="/404" />
                </Switch>
              </Container>
            </main>
          </div>
          <AppFooter>
            <DefaultFooter />
          </AppFooter>
        </div>
      );
    } else {
      this.logout();
      return <div className="app" />;
    }
  }
}

export default DefaultLayout;
